import { request } from "../../../apis";

export const apiGetFaqList = (): any =>
  request("get", `/api/faq/list`, null, true);

export const apiGetFaqCategory = (): any =>
  request("get", `/api/faq/category/list`, null, true);
